import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storage } from '@/configs/storage';
import { POST_SORT_STORE_KEY } from '@/features/posts/constants/store';
import { PostSortEnum } from '@/features/posts/types/postSort';

export type PostSortStore = {
  sort: PostSortEnum;
  setSort: (sort: PostSortEnum) => void;
};

export const usePostSortStore = create<PostSortStore>()(
  persist(
    (set) => ({
      sort: PostSortEnum.LastActivity,
      setSort: (newSort: PostSortEnum) => {
        set({ sort: newSort });
      }
    }),
    { name: POST_SORT_STORE_KEY, storage: createJSONStorage(() => storage) }
  )
);
